<ui-card class="subscription-overview" [class.loading]="isLoading">
    <ui-button
        type="primary"
        *ngIf="isSelfServeModulesFlagEnabled && subscriptions?.length"
        size="compact"
        (click)="edit.emit()"
    >
        {{ 'settings.subscription-overview.addModulesButton' | translate }}
    </ui-button>

    <app-segment-header title="{{ 'settings.subscription-overview.header' | translate }}"></app-segment-header>

    <ng-container [ngTemplateOutlet]="isSelfServeCustomer ? selfServeView : modulesView" />
</ui-card>

<ng-template #selfServeView>
    <ui-card *ngIf="!invalidSelfServeConfiguration" class="self-serve" variant="outline">
        <div
            class="plan-name"
            translate="settings.subscription-overview.selfServe.plans.{{ selfServePlan?.toUpperCase() }}"
        ></div>
        <div class="cost" *ngIf="!isLoading">
            <ng-container
                [ngTemplateOutlet]="displayMonthly"
                [ngTemplateOutletContext]="{ amount: selfServePricingInfo.flatTotal / 100 }"
            />
            <div class="font-secondary">
                {{ 'settings.subscription-overview.selfServe.applicableTaxes' | translate }}
            </div>
        </div>
        <div class="disclaimer" *ngIf="!isLoading">
            <div *ngFor="let tier of selfServePricingInfo.tieredPricing">
                <span *ngIf="tier.flatAmount">
                    {{
                        'settings.subscription-overview.selfServe.tieredPricing.flatAmount'
                            | translate
                                : {
                                      maxEmployees: tier.upTo,
                                      amount: tier.flatAmount / 100 | currency: undefined : 'symbol-narrow' : '1.0-0',
                                  }
                    }}
                </span>
                <span *ngIf="tier.amount">
                    {{
                        'settings.subscription-overview.selfServe.tieredPricing.perUnit'
                            | translate
                                : {
                                      maxEmployees: tier.upTo,
                                      amount: tier.amount / 100 | currency: undefined : 'symbol-narrow' : '1.0-0',
                                  }
                    }}
                </span>
            </div>
        </div>
    </ui-card>
    <a href="{{ 'new' | i18nHelpCentre }}" target="_blank">{{
        'settings.subscription-overview.selfServe.help' | translate
    }}</a>
</ng-template>

<ng-template #modulesView>
    <ng-container *ngIf="subscriptions?.length; else noSubscription">
        <mat-expansion-panel *ngFor="let subscription of subscriptions">
            <!-- Header -->
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <ng-container *ngIf="subscription.subscriptionItems.length - 1">
                        + {{ subscription.subscriptionItems.length - 1 }}
                        {{ 'settings.subscription-overview.additionalModulesLabel' | translate }}
                    </ng-container>
                </mat-panel-title>
                <mat-panel-description>
                    <ng-container
                        [ngTemplateOutlet]="displayMonthly"
                        [ngTemplateOutletContext]="{ amount: subscription.amount }"
                    />
                </mat-panel-description>
            </mat-expansion-panel-header>
            <!-- Content -->
            <table class="table">
                <thead>
                    <tr>
                        <th>{{ 'settings.subscription-overview.productColumn' | translate }}</th>
                        <th>{{ 'settings.subscription-overview.pricingColumn' | translate }}</th>
                        <th>{{ 'settings.subscription-overview.numberOfSeatsColumn' | translate }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of subscription.subscriptionItems">
                        <td>{{ productById(item.product)?.name }}</td>
                        <td *ngIf="productById(item.product)?.perEmployee">
                            {{
                                'settings.subscription-overview.productPerEmployeePrice'
                                    | translate
                                        : {
                                              amount: item.amount,
                                              interval: item.interval,
                                              unit: productById(item.product)?.unitLabel,
                                          }
                            }}
                        </td>
                        <td *ngIf="!productById(item.product)?.perEmployee">
                            {{
                                'settings.subscription-overview.productPerIntervalPrice'
                                    | translate: { amount: item.amount, interval: item.interval }
                            }}
                        </td>
                        <td *ngIf="productById(item.product)?.perEmployee">{{ item.quantity }}</td>
                        <td *ngIf="!productById(item.product)?.perEmployee">-</td>
                        <td *ngIf="isSelfServeModulesFlagEnabled && !productById(item.product)?.isRequired">
                            <ui-button type="icon" (click)="cancel.emit(item)"
                                ><mat-icon svgIcon="cancel"></mat-icon
                            ></ui-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>
    </ng-container>
    <ng-template #noSubscription>
        {{ 'settings.subscription-overview.noSubscriptionsMessage' | translate }}
    </ng-template>
</ng-template>

<ng-template #displayMonthly let-amount="amount">
    <div class="dollar">
        <span>{{ amount | currency }}</span
        >{{ 'settings.subscription-overview.perMonthSuffix' | translate }}
    </div>
</ng-template>
